/**
 *
 * @module configurationClientExtrasMap
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyObject
} = Check.assert;

/**
 *
 * @class ConfigurationClientExtrasMap
 * @desc Used to expose the list of configuration host names and corresponding baseUrls
 * in the `ConfigurationClientConfiguration`
 *
 */
export default class ConfigurationClientExtrasMap {

    /**
     *
     * @param {Object} configHostParams
     *
     */
    constructor(configHostParams) {

        const errorMessage = {
            ctor: 'ConfigurationClientExtrasMap(configHostParams)',
            get configHostParams() {
                return `${this.ctor} configHostParams should be a plain Object`;
            }
        };

        nonEmptyObject(configHostParams, errorMessage.configHostParams, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {Object}
         * @desc The object containing the list of configuration host names and corresponding baseUrls
         *
         */
        this.configHostParams = configHostParams;

    }

}



// WEBPACK FOOTER //
// ./src/services/configuration/configurationClientExtrasMap.js